module.exports = __webpack_public_path__ + "01_long_gold.f53201d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/01_long_gold.png
// module id = ZUJ0
// module chunks = 0